import React, { useEffect, useRef, useState } from "react";
import Library from "./components/Library";
import Player from "./components/Player";
import Song from "./components/Song";
import "./styles.css";
import data from "./util";
import Nav from "./components/Nav";
import Topbar from "./components/Topbar";
// import Carousel from "./components/Carousel";
import axios from "axios";
import getPlaylist from "./api/getPlaylist";
import getSong from "./api/getSong";

export default function App() {
  const audioRef = useRef(null);

  // STATE
  const [isLoading, setIsLoading] = useState(true); 
  const [autoPlay, setAutoPlay] = useState(true);
  const [darkMode, setDarkMode] = useState(true);
  const [songInfo, setSongInfo] = useState({
    currentTime: 0,
    duration: 0,
  });
  const [songs, setSongs] = useState(data());
  const [currentSong, setCurrentSong] = useState({});
  const [isPlaying, setIsPlaying] = useState(false);
  const [renderLibrary, setRenderLibrary] = useState(false);
  const [navContent, setNavContent] = useState(false);

  // HANDLERS
  const timeUpdateHandler = (e) => {
    const current = e.target.currentTime;
    const duration = e.target.duration;
    setSongInfo({ ...songInfo, currentTime: current, duration });
  };
  const nextSongHandler = async () => {
    const currentIndex = songs.findIndex((song) => {
      return currentSong.id === song.id;
    });
    const nextSongIndex = currentIndex + 1;
    if (nextSongIndex < songs.length) {
      const nextSong = await getSong(songs[nextSongIndex].id);
      setCurrentSong(nextSong);
    } else {
      const nextSong = await getSong(songs[0].id);
      setCurrentSong(nextSong);
    }
    if (isPlaying) {
      audioRef.current.play();
    }
  };
  const autoPlayHandler = () => {
    if (autoPlay) {
      nextSongHandler();
    } else setIsPlaying(false);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getPlaylist();
        setSongs(data);
        const currentSongData = await getSong(data[0].id);
        setCurrentSong(currentSongData);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  return (
    <div
      className={`bg-[#181c22] h-screen w-screen overflow-hidden ${darkMode && "dark"
        }`}
    >
      <div className="dark:bg-[#141824] absolute bg-[#EBEBD3] font-varela h-screen w-screen">
        <Topbar
          navContent={navContent}
          setNavContent={setNavContent}
          darkMode={darkMode}
          setDarkMode={setDarkMode}
          songs={songs}
          setSongs={setSongs}
          setCurrentSong={setCurrentSong}
          setIsLoading={setIsLoading}
          isPlaying={isPlaying}
          audioRef={audioRef}
        />
        <Song currentSong={currentSong} isLoading={isLoading}/>
        <Player
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
          currentSong={currentSong}
          setCurrentSong={setCurrentSong}
          songInfo={songInfo}
          setSongInfo={setSongInfo}
          timeUpdateHandler={timeUpdateHandler}
          audioRef={audioRef}
          songs={songs}
          setSongs={setSongs}
          nextSongHandler={nextSongHandler}
          setIsLoading={setIsLoading}
        />
        <Nav
          renderLibrary={renderLibrary}
          setRenderLibrary={setRenderLibrary}
        />
        <Library
          songs={songs}
          setSongs={setSongs}
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
          setCurrentSong={setCurrentSong}
          timeUpdateHandler={timeUpdateHandler}
          currentSong={currentSong}
          audioRef={audioRef}
          renderLibrary={renderLibrary}
          setAutoPlay={setAutoPlay}
          autoPlay={autoPlay}
          setIsLoading={setIsLoading}
        />
        <audio
          ref={audioRef}
          src={currentSong.audio}
          onTimeUpdate={timeUpdateHandler}
          onLoadedMetadata={timeUpdateHandler}
          onEnded={autoPlayHandler}
        ></audio>
      </div>
    </div>
  );
}
